<template>
    
    <div class="visual_bufferstation">

        <svg version="1.1" id="Laag_1" v-bind:class="{ visual_bufferstation_active: status }" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 649.63 132.27" style="enable-background:new 0 0 649.63 132.27;" xml:space="preserve">
        
        <line class="st0" x1="23.7" y1="73.8" x2="191" y2="73.8"/>
        <path class="bufferStatus" d="M271.6,66.8h-15v-2.7h6.8c0.8,0,1.4-0.6,1.4-1.4v-4.1h4.1c0.8,0,1.4-0.6,1.4-1.4V40.9c0-0.8-0.6-1.4-1.4-1.4h-4.1v-4.1
            c0-0.8-0.6-1.4-1.4-1.4h-13.7v-2.7h5.5c0.8,0,1.4-0.6,1.4-1.4v-5.5c0-0.5-0.3-1-0.8-1.2l-2.7-1.4c-0.2-0.1-0.4-0.1-0.6-0.1h-2.7
            v-4.1c0-0.8-0.6-1.4-1.4-1.4h-8.2c-0.8,0-1.4,0.6-1.4,1.4v4.1h-2.7c-0.2,0-0.4,0-0.6,0.1l-2.7,1.4c-0.5,0.2-0.8,0.7-0.8,1.2V30
            c0,0.8,0.6,1.4,1.4,1.4h5.5v2.7h-9.6c-0.4,0-0.8,0.2-1.1,0.5l-4.1,5.5c-0.2,0.2-0.3,0.5-0.3,0.8v2.7h-5.5V31.3h2.7v-2.7h-13.7v2.7
            h2.7v6.8H206c-0.4,0-0.7,0.1-1,0.4l-2.7,2.7c-0.3,0.3-0.4,0.6-0.4,1V45h-8.2v13.7h2.7v-5.5h5.5v2.7c0,0.4,0.1,0.7,0.4,1l2.7,2.7
            c0.3,0.3,0.6,0.4,1,0.4h4.1v6.8h-17.8c-0.8,0-1.4,0.6-1.4,1.4v10.9c0,0.8,0.6,1.4,1.4,1.4h79.2c0.8,0,1.4-0.6,1.4-1.4V68.2
            C272.9,67.5,272.3,66.8,271.6,66.8z M253.8,66.8h-2.7v-2.7h2.7V66.8z M240.2,66.8v-2.7h8.2v2.7H240.2z M218.3,66.8V54.5h5.5v2.7
            c0,0.3,0.1,0.6,0.3,0.8l4.1,5.5c0.3,0.3,0.7,0.6,1.1,0.6h2.7v2.7L218.3,66.8L218.3,66.8z M234.7,64.1h2.7v2.7h-2.7V64.1z
            M267.5,42.3v13.7h-2.7V42.3H267.5z M241.5,19h5.5v2.7h-5.5V19z M234.7,25.4l1.7-0.8h15.8l1.7,0.8v3.2h-19.1L234.7,25.4L234.7,25.4z
            M241.5,31.3h5.5v2.7h-5.5V31.3z M226.5,41.3l3.4-4.5H262v24.6h-32.1l-3.4-4.5V41.3z M223.8,46.4v5.5h-5.5v-5.5H223.8z M212.8,31.3
            h2.7v6.8h-2.7V31.3z M196.4,50.5v-2.7h5.5v2.7H196.4z M204.6,55.3V42.8l1.9-1.9h9v16.4h-9L204.6,55.3z M212.8,60h2.7v6.8h-2.7V60z
            M270.2,77.8h-76.5v-8.2h76.5V77.8z"/>
        <line class="st0" x1="272.9" y1="73.8" x2="390.8" y2="73.8"/>
        <line class="st0" x1="35.5" y1="73.7" x2="35.5" y2="57.3"/>
        <circle class="st0" cx="35.5" cy="39.5" r="17.8"/>
        <g>
            <path d="M32.1,33.1c0.8-0.1,1.9-0.3,3.3-0.3c1.7,0,3,0.4,3.8,1.1c0.7,0.6,1.2,1.6,1.2,2.8c0,1.2-0.4,2.2-1,2.9
                c-0.9,1-2.4,1.5-4.1,1.5c-0.5,0-1,0-1.4-0.1v5.4h-1.7C32.1,46.4,32.1,33.1,32.1,33.1z M33.9,39.6c0.4,0.1,0.9,0.1,1.4,0.1
                c2.1,0,3.4-1,3.4-2.9c0-1.8-1.3-2.6-3.2-2.6c-0.8,0-1.3,0.1-1.6,0.1V39.6z"/>
        </g>
        <rect x="62.7" y="27.6" class="st0" width="53.6" height="21.9"/>
        <rect x="68" y="33.4" class="st1" width="45" height="12.2"/>
        <text transform="matrix(1 0 0 1 68.0284 42.6322)" class="st2 st3">{{network_preasure}}</text>
        <g>
            <path d="M125,37.9c0-0.7,0-1.3-0.1-1.8h1.1l0.1,1.1h0c0.4-0.6,1-1.2,2.1-1.2c0.9,0,1.6,0.6,1.9,1.4h0c0.2-0.4,0.5-0.7,0.8-0.9
                c0.4-0.3,0.9-0.5,1.5-0.5c0.9,0,2.2,0.6,2.2,2.9v4h-1.2V39c0-1.3-0.5-2.1-1.5-2.1c-0.7,0-1.2,0.5-1.5,1.1c-0.1,0.2-0.1,0.4-0.1,0.6
                v4.2h-1.2v-4.1c0-1.1-0.5-1.9-1.4-1.9c-0.8,0-1.3,0.6-1.5,1.2c-0.1,0.2-0.1,0.4-0.1,0.6v4.1H125V37.9z"/>
            <path d="M139.6,42.8c0-0.5,0.1-1.2,0.1-1.8v-8.2h1.2v4.3h0c0.4-0.8,1.2-1.2,2.3-1.2c1.7,0,2.9,1.4,2.9,3.5c0,2.4-1.5,3.6-3,3.6
                c-1,0-1.8-0.4-2.3-1.3h0l-0.1,1.1L139.6,42.8L139.6,42.8z M140.9,40.1c0,0.2,0,0.3,0.1,0.5c0.2,0.8,0.9,1.4,1.9,1.4
                c1.3,0,2.1-1,2.1-2.6c0-1.4-0.7-2.5-2-2.5c-0.8,0-1.6,0.6-1.9,1.5c0,0.1-0.1,0.3-0.1,0.5L140.9,40.1L140.9,40.1z"/>
            <path d="M151.4,42.8l-0.1-0.8h0c-0.4,0.5-1.1,1-2.1,1c-1.4,0-2.1-1-2.1-2c0-1.6,1.5-2.5,4.1-2.5v-0.1c0-0.6-0.1-1.6-1.5-1.6
                c-0.6,0-1.3,0.2-1.8,0.5l-0.3-0.8c0.6-0.4,1.4-0.6,2.2-0.6c2.1,0,2.6,1.4,2.6,2.8v2.5c0,0.6,0,1.2,0.1,1.6H151.4z M151.2,39.4
                c-1.3,0-2.9,0.2-2.9,1.5c0,0.8,0.5,1.2,1.2,1.2c0.9,0,1.4-0.6,1.6-1.1c0-0.1,0.1-0.3,0.1-0.4L151.2,39.4L151.2,39.4z"/>
            <path d="M154.4,38.2c0-0.8,0-1.5-0.1-2.1h1.1l0,1.3h0.1c0.3-0.9,1.1-1.5,1.9-1.5c0.1,0,0.2,0,0.4,0v1.2c-0.1,0-0.2,0-0.4,0
                c-0.9,0-1.5,0.7-1.6,1.6c0,0.2-0.1,0.4-0.1,0.6v3.6h-1.2L154.4,38.2L154.4,38.2z"/>
        </g>
        <rect x="191.4" y="92.5" class="st0" width="53.6" height="21.9"/>
        <rect x="196.8" y="98.3" class="st1" width="45" height="12.2"/>
        <text transform="matrix(1 0 0 1 196.7501 107.56)" class="st2 st3">{{rpm}}</text>
        <path class="st4" d="M390.8,74.9c0.7,8,7.4,14.2,15.4,14.2h205.1c1.6,0,2.9-1.3,2.9-2.9V59.5c0-0.7-0.6-1.2-1.2-1.2l0,0H406.2
            c-8,0-14.7,6.2-15.4,14.2 M610,86.6L610,86.6c-0.9,0-1.6-0.7-1.6-1.6V62.3c0-0.9,0.7-1.6,1.6-1.6l0,0c0.9,0,1.6,0.7,1.6,1.6V85
            C611.6,85.9,610.9,86.6,610,86.6z M406.6,60.7h197.7c0.9,0,1.6,0.7,1.6,1.6V85c0,0.9-0.7,1.6-1.6,1.6H406.2c-7.4,0-13.3-6.1-13-13.6
            C393.6,66.1,399.6,60.7,406.6,60.7z"/>
        <rect x="422.5" y="65" class="st0" width="41.9" height="17"/>
        <rect x="427.8" y="68.8" class="st1" width="32.9" height="11.7"/>
        <text transform="matrix(1 0 0 1 427.7906 77.2867)" class="st2 st5">{{buffer_preasure}}</text>
        <g>
            <path d="M472.5,78.2c0-0.5,0.1-1.2,0.1-1.8v-8.2h1.2v4.3h0c0.4-0.8,1.2-1.2,2.3-1.2c1.7,0,2.9,1.4,2.9,3.5c0,2.4-1.5,3.6-3,3.6
                c-1,0-1.8-0.4-2.3-1.3h0l-0.1,1.1L472.5,78.2L472.5,78.2z M473.8,75.5c0,0.2,0,0.3,0.1,0.4c0.2,0.8,1,1.4,1.9,1.4
                c1.3,0,2.1-1.1,2.1-2.6c0-1.4-0.7-2.5-2-2.5c-0.8,0-1.6,0.6-1.9,1.5c0,0.1-0.1,0.3-0.1,0.5V75.5z"/>
            <path d="M484.3,78.2l-0.1-0.8h0c-0.4,0.5-1.1,1-2.1,1c-1.4,0-2.1-1-2.1-1.9c0-1.6,1.5-2.5,4.1-2.5v-0.1c0-0.6-0.1-1.6-1.5-1.6
                c-0.6,0-1.3,0.2-1.8,0.5l-0.3-0.8c0.6-0.4,1.4-0.6,2.2-0.6c2.1,0,2.6,1.4,2.6,2.8v2.5c0,0.6,0,1.2,0.1,1.6L484.3,78.2L484.3,78.2z
                M484.1,74.7c-1.3,0-2.9,0.2-2.9,1.5c0,0.8,0.5,1.2,1.2,1.2c0.9,0,1.4-0.6,1.6-1.1c0-0.1,0.1-0.3,0.1-0.4L484.1,74.7L484.1,74.7z"
                />
            <path d="M487.3,73.5c0-0.8,0-1.5-0.1-2.1h1.1l0,1.3h0.1c0.3-0.9,1-1.5,1.9-1.5c0.1,0,0.2,0,0.4,0v1.2c-0.1,0-0.2,0-0.4,0
                c-0.9,0-1.5,0.7-1.6,1.6c0,0.2-0.1,0.4-0.1,0.6v3.6h-1.2V73.5z"/>
        </g>
        <rect x="558.4" y="64.8" class="st0" width="41.9" height="17.1"/>
        <rect x="567.8" y="68.6" class="st1" width="32.9" height="11.7"/>
        <text transform="matrix(1 0 0 1 567.7486 77.1574)" class="st2 st5">{{ inhoud }}</text>
        <rect x="280" y="20.4" class="st6" width="158.6" height="28"/>
        <rect x="286.3" y="29.5" class="st1" width="31.6" height="16.5"/>
        <text transform="matrix(1 0 0 1 286.3457 38.7034)" class="st7 st3">{{getOnOff()}}</text>
        <line class="st8" x1="319.9" y1="26.4" x2="319.9" y2="42.1"/>
        <rect x="331.8" y="29.5" class="st1" width="107.2" height="12.4"/>
        <text transform="matrix(1 0 0 1 331.8154 38.7029)" class="st7 st3">{{lastModified}}</text>
        <rect x="251.7" y="98.1" class="st1" width="31.6" height="13.3"/>
        <text transform="matrix(1 0 0 1 251.6786 107.38)" class="st7 st3">RPM</text>
        </svg>


    </div>

</template>

<style scoped>

    .st0{fill:none;stroke:#000000;stroke-miterlimit:10;}
	.st1{fill:none;}
	.st2{font-family:'Arial';}
	.st3{font-size:13px;}
	.st4{fill:#020203;}
	.st5{font-size:12px;}
	.st6{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}
	.st7{font-family:'Arial';}
	.st8{fill:none;stroke:#939393;stroke-miterlimit:10;}     

    .visual_bufferstation_active .bufferStatus {
        fill: #62B337;
    }

</style>


<script>

import helpers from "@/helpers";
import moment from "moment-timezone" ;

export default {
    
    data () {
        return {
            status: true,
            inhoud: null,
            rpm: null,
            buffer_preasure: null,
            network_preasure: null,
            lastModified: null
        }
    },
    methods: {

        getOnOff(){

            if(this.status){
                return this.$t('On');
            }else{
                return this.$t('Off');
            }
            
        }

    },
    props: {
        device: {
            type: Object,
            required: false,
            default: null
        },
    },
    created() {

        var _this = this ; 

        // Get tags
        this.device.db.collection('tags').onSnapshot(function(querySnapshot) {

            querySnapshot.forEach(function(doc) {

                let tag = doc.data() ;
                tag.id = doc.id ; 

                // status
                if(tag.id == 'e68313b7dba646ae9063'){
                    
                    if(tag.last_updated){
                        _this.lastModified  = moment.unix(tag.last_updated).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm") ;
                    }

                    if(tag.value == '1'){
                        _this.status = true ; 
                    }else{
                        _this.status = false ;
                    }

                }

                // inhoud procent
                if(tag.id == '375d26d8647b4108b291'){
                    
                    _this.inhoud = Math.round(helpers.get_tagValue(tag, true))+"%" ; 

                }

                // rpm
                if(tag.id == '3cb922154ada4d30b8ba'){
                    
                    _this.rpm = Math.round(helpers.get_tagValue(tag, true)); 

                    // $(".visual_buffer_hours").text(Math.round(tag.data().value)) ;

                }

                // Buffer Pressure
                if(tag.id == 'e847f09cb9044b409e6c'){
                    
                    _this.buffer_preasure = helpers.get_tagValue(tag, true) ; 

                    // $(".visual_buffer_pressure").text(tag.data().value) ;

                }

                // network preasure
                if(tag.id == '7ba3f6f6ebff460b8cee'){
                    
                    _this.network_preasure = helpers.get_tagValue(tag, true) ; 

                    // $(".visual_buffer_network_pressure").text(tag.data().value) ;
                }

            });

        });

        

    }

}

</script>